import Config from '@/config'

export default class FileProxy {
  static get stratesBaseUrl () {
    return `${Config.apiBaseUrl}/file`
  }

  static getFileUrl (id) {
    return `${FileProxy.stratesBaseUrl}/${id}`
  }
}